import { atom } from 'jotai';

import { loadNotesUpdateAtom } from '../_graphql/mutationLoadNotesUpdate';

import { createAutoSaveFormAtoms } from './createAutoSaveFormAtoms.state';
import { $outboundLoads, $outboundTicketDetail } from './scaleTicketPro.state';

export type OutboundNotesFormState = {
  recyclerInternalNotes: string | null;
  recyclerExternalNotes: string | null;
  customerInternalNotes: string | null;
  customerExternalNotes: string | null;
};

export const DEFAULT_OUTBOUND_NOTES_FORM: OutboundNotesFormState = {
  recyclerInternalNotes: null,
  recyclerExternalNotes: null,
  customerInternalNotes: null,
  customerExternalNotes: null,
};

type OutboundNotesServerData = {
  recyclerInternalNotes?: string | null;
  recyclerExternalNotes?: string | null;
  customerInternalNotes?: string | null;
  customerExternalNotes?: string | null;
};

const atoms = createAutoSaveFormAtoms<
  OutboundNotesFormState,
  OutboundNotesServerData
>({
  defaultForm: DEFAULT_OUTBOUND_NOTES_FORM,
  fromServerData: (load) => ({
    recyclerInternalNotes: load.recyclerInternalNotes ?? null,
    recyclerExternalNotes: load.recyclerExternalNotes ?? null,
    customerInternalNotes: load.customerInternalNotes ?? null,
    customerExternalNotes: load.customerExternalNotes ?? null,
  }),
  createMutation: (onSuccess, onError) => {
    const $mut = loadNotesUpdateAtom({
      onSuccess: (get, set, { params }) => onSuccess(get, set, params.id),
      onError: (get, set, { params }) => onError(get, set, params.id),
    });
    return atom(
      null,
      (
        _get,
        set,
        params: { ticketId: string; form: OutboundNotesFormState },
      ) => {
        set($mut, {
          id: params.ticketId,
          recyclerInternalNotes: params.form.recyclerInternalNotes ?? '',
          recyclerExternalNotes: params.form.recyclerExternalNotes ?? '',
          customerInternalNotes: params.form.customerInternalNotes ?? '',
          customerExternalNotes: params.form.customerExternalNotes ?? '',
        });
      },
    );
  },
  refetchOnSuccess: (get) => {
    get($outboundTicketDetail).refetch();
    get($outboundLoads).refetch();
  },
});

export const $outboundNotesFormById = atoms.$formById;
export const $outboundNotesBaselineById = atoms.$baselineById;
export const $updateOutboundNotesField = atoms.$updateField;
export const $syncOutboundNotesForm = atoms.$syncForm;
export const $flushOutboundNotesAutoSave = atoms.$flushAutoSave;
export const $cancelOutboundNotesAutoSave = atoms.$cancelAutoSave;
export const $cleanupOutboundNotesForm = atoms.$cleanupForm;
